module.exports = __webpack_public_path__ + "conf_send.png?8fe4867bf731d523a5cc0afe69469fa9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/conf_send.png
// module id = 65
// module chunks = 0